export const UPLOAD_SCRIPT_TYPE = [
  {
    key: 1,
    label: "Update Bajaj Loan Provider Details",
    value: "UPDATE_BAJAJ_LOAN_PROVIDER_DETAILS",
  },
  {
    key: 2,
    label: "Process Refunds",
    value: "PROCESS_REFUNDS",
  },
  {
    key: 3,
    label: "Process Propelled Loan Disbursement",
    value: "PROCESS_PROPELLED_LOAN_DISBURSEMENT",
  },
  {
    key: 4,
    label: "Process Fibe Loan Disbursement",
    value: "PROCESS_FIBE_LOAN_DISBURSEMENT",
  },
  {
    key: 5,
    label: "Upload Day Sheet Cash Disbursement",
    value: "UPLOAD_DAY_SHEET_CASH_DISBURSEMENT",
  },
  {
    key: 6,
    label: "Update Day Sheet Cash Disbursement",
    value: "UPDATE_DAY_SHEET_CASH_DISBURSEMENT",
  },
];

export const SELECTED_SCRIPT_IDS = {
  UPDATE_BAJAJ_LOAN_PROVIDER_DETAILS: 1,
  PROCESS_REFUNDS: 2,
  PROCESS_PROPELLED_LOAN_DISBURSEMENT: 10,
  PROCESS_FIBE_LOAN_DISBURSEMENT: 13,
  UPLOAD_DAY_SHEET_CASH_DISBURSEMENT: 14,
  UPDATE_DAY_SHEET_CASH_DISBURSEMENT: 15,
};

export const FILE_UPLOAD_STATUS = {
  CREATED: 1,
  UPLOADED: 2,
  PROCESSED: 3,
};

export const FINANCE_MODULE_ID = 1;

export const LEARN_VERTICAL_ID = 1;
export const SCA_VERTICAL_ID = 2;

export const VALID_VERTICAL_IDS = [LEARN_VERTICAL_ID, SCA_VERTICAL_ID];

export const INDIAN_ISD_CODE = "+91";

export const BUSINESS_VERTICAL_IDS = [
  {
    id: LEARN_VERTICAL_ID,
    value: "1",
    label: "Learn",
  },
  {
    id: SCA_VERTICAL_ID,
    value: "2",
    label: "SCA",
  },
];

export const LEARN_TENANT_ID = 1;
export const LEARN_PRODUCT_ID = 300;

export const CHEQUE_STATUS_IDS = {
  CREATED: 1,
  VERIFIED: 2,
  DISBURSED: 3,
  CANCELLED: 4,
  FAILED: 5,
};

export const CASH_STATUS_IDS = {
  CREATED: 1,
  DISBURSED: 2,
  CANCELLED: 3,
};

export const BANK_TRANSFER_STATUS_IDS = {
  CREATED: 1,
  DISBURSED: 2,
  CANCELLED: 3,
  FAILED: 4,
};

export const PAYMENT_STATUS = {
  CREATED: 1,
  VERIFIED: 2,
  ACTIVATED_BY_PROVIDER: 3,
  REJECTED_BY_PROVIDER: 4,
  CANCELLED_BY_CUSTOMER: 5,
  REJECTED_BY_INFINITY_LEARN: 6,
  APPROVED_BY_PROVIDER: 7,
  DISBURSED: 8,
};

export const BANK_TRANSFER_UPDATE_RELOAD_DELAY_IN_MS = 500;

export const VERTICAL_NAME = {
  [SCA_VERTICAL_ID]: "SCA",
  [LEARN_VERTICAL_ID]: "Learn",
};

export const DAY_SHEET_REPORTS = "DAY_SHEET_REPORTS";

export const DOWNLOAD_SCRIPT_TYPE = [
  {
    key: 1,
    label: "Day Sheet Reports",
    value: "DAY_SHEET_REPORTS",
  }
];

export const DAY_SHEET_COLUMNS = [
  { label: "Day-Sheet ID", field: "id" },
  { label: "Day-Sheet Close Date", field: "closed_at" },
  { label: "Created By", field: "created_by" },
  { label: "Total Amount (₹)", field: "total_amount" },
  { label: "Download", field: "download" },
];


export const DAY_SHEET_TYPES = [
  {
    key: 1,
    label: "ONLINE",
    value: "ONLINE",
  },
  {
    key: 2,
    label: "OFFLINE",
    value: "OFFLINE",
  },
];

export const CASH_PAYMENT_METHOD_ID = 6;
